import {Component, OnDestroy, OnInit} from '@angular/core';
import {ToolsService} from '../../shared/services/tools.service';
import {FormControl, FormGroup} from '@angular/forms';
import {UserCreate} from '../../shared/models/user.model';
import {DataStorageService} from '../../shared/services/data-storage.service';
import {AuthenticationService} from '../../authentication/authentication.service';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators';

@Component({
    templateUrl: 'form-create-user.html',
    selector: 'form-create-user'
})

export class FormCreateUserComponent implements OnInit, OnDestroy {

    accountForm: FormGroup;

    stateOptions: any = [];
    userLevelOptions: any = [];
    selectConfig: any = {
        labelField: 'label',
        valueField: 'value',
        searchField: ['value']
    };

    newUser: UserCreate;

    private unsubscribe$: Subject<void> = new Subject<void>();

    constructor(private toolsService: ToolsService,
                private dataStorageService: DataStorageService,
                private authenticationService: AuthenticationService) {
    }

    ngOnInit() {
        this.stateOptions = this.toolsService.getStateOptions();
        this.userLevelOptions = this.toolsService.getUserLevelOptions();
        this.initForm();
    }

    initForm() {
        this.accountForm = new FormGroup({
            'user_name': new FormControl(),
            'agency_name': new FormControl(),
            'first_name': new FormControl(),
            'last_name': new FormControl(),
            'email': new FormControl(),
            'phone': new FormControl(),
            'fax': new FormControl(),
            'address1': new FormControl(),
            'address2': new FormControl(),
            'city': new FormControl(),
            'state': new FormControl(),
            'zip': new FormControl(),
            'password': new FormControl(),
            'level': new FormControl(),
            'is_active': new FormControl()
        });
    }

    onSubmit() {

        const value = this.accountForm.value;
        this.newUser = new UserCreate(
            value.user_name, value.password, value.agency_name, value.last_name, value.first_name,
            value.email, value.phone,
            value.level, false, value.is_active);

        if (value.address1) {
            this.newUser['address1'] = value.address1;
        }
        if (value.address2) {
            this.newUser['address2'] = value.address2;
        }
        if (value.city) {
            this.newUser['city'] = value.city;
        }
        if (value.state) {
            this.newUser['state'] = value.state;
        }
        if (value.zip) {
            this.newUser['zip'] = value.zip;
        }
        if (value.fax) {
            this.newUser['fax'] = value.fax;
        }


        this.authenticationService.signup(this.newUser)
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
                responseData => {
        });

    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
